import { InfoCircleOutlined, PieChartOutlined } from '@ant-design/icons';
import { Space, Tag } from 'antd';
import { Link } from 'react-router-dom';

import UIIconTooltip from 'common/ui/UIIconTooltip';

import { activeColors, activeLabels } from 'utils/constants';
import { formatDateTime, isZeroDate } from 'utils/formatDate';

export const userProgramsColumns = () => {
  return [
    {
      title: '',
      dataIndex: 'id',
      align: 'center',
      render: id => <Link to={`/investment/user-programs/${id}`}>View</Link>,
    },
    {
      title: 'Created',
      dataIndex: 'created_at',
      sorter: true,
      render: value => formatDateTime(value),
    },
    {
      title: 'User',
      dataIndex: 'user_id',
      align: 'center',
      render: userId => (
        <Link to={`/investment/users/${userId}`}>View user</Link>
      ),
    },
    {
      title: 'Tên',
      dataIndex: 'program_name',
    },
    {
      title: 'Ngày bắt đầu',
      dataIndex: 'start_date',
      type: 'date',
    },
    {
      title: 'Ngày kết thúc',
      dataIndex: 'end_date',
      type: 'date',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      align: 'center',
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <Space>
          <Link to={`/investment/user-programs/${record.id}`}>
            <UIIconTooltip title="Detail" Icon={InfoCircleOutlined} />
          </Link>
          <Link to={`/investment/user-programs/${record.id}/portfolio`}>
            <UIIconTooltip title="View Portfolio" Icon={PieChartOutlined} />
          </Link>
        </Space>
      ),
    },
  ];
};

export const userProgramInvestmentPlanColumns = () => [
  {
    title: 'Status',
    dataIndex: 'is_active',
    render: isActive => {
      const status = isActive ? 'active' : 'inactive';
      return <Tag color={activeColors[status]}>{activeLabels[status]}</Tag>;
    },
  },

  {
    title: 'Product Code',
    dataIndex: 'user_investment_details',
    key: 'product_code',

    render: detail => (
      <div>
        {detail?.map(e => (
          <p>{e.product_code}</p>
        ))}
      </div>
    ),
  },
  {
    title: 'Percentage',
    dataIndex: 'user_investment_details',
    key: 'percentage',
    render: detail => (
      <div>
        {detail?.map(e => (
          <p>{e.percentage}%</p>
        ))}
      </div>
    ),
  },
  {
    title: 'Amount',
    dataIndex: 'user_investment_details',
    key: 'amount',

    render: detail => (
      <div>
        {detail?.map(e => (
          <p>{new Intl.NumberFormat('en-US').format(e.amount)}</p>
        ))}
      </div>
    ),
  },
  {
    title: 'Version',
    dataIndex: 'investment_plan_version',
  },
  {
    title: 'Activated At',
    dataIndex: 'activated_at',
    render: value => {
      if (isZeroDate(value)) return '-';
      return formatDateTime(value);
    },
  },
];
